import { render, staticRenderFns } from "./InventarioPosicionProductoModalComponent.vue?vue&type=template&id=70749ad4&"
import script from "./InventarioPosicionProductoModalComponent.vue?vue&type=script&lang=js&"
export * from "./InventarioPosicionProductoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports